import { ModalPrompt, Text } from "@repo/skapa";
import { t } from "@repo/translation";

import { FileLoadingEnum } from "../utils";

export const DownloadAllModal = ({
  visible,
  loading,
  onClose,
  onConfirm,
}: {
  visible?: boolean;
  loading?: FileLoadingEnum;
  onClose: () => void;
  onConfirm: () => void;
}) => (
  <ModalPrompt
    titleId="download-all-file-modal-title"
    title={t("action.download_all_files")}
    visible={visible}
    onClose={onClose}
    primaryButtonProps={{
      text: t("label.yes"),
      onClick: onConfirm,
      loading: loading === FileLoadingEnum.DOWNLOADING_ALL,
    }}
    secondaryButtonProps={{
      text: t("label.no"),
      onClick: onClose,
    }}
  >
    <Text>{t("prompt.confirm_download_all_files")}</Text>
  </ModalPrompt>
);
